import React from 'react';

const Banner = ({ children }) => {

	return (
		<div className="banner">
			{children}
		</div>
	);
};

export default Banner;